export default "__VITE_ASSET__D4xE3AfQ__ 400w, __VITE_ASSET__CuMDc21t__ 800w, __VITE_ASSET__Dupul8h1__ 1024w";